import React from 'react';

import { Add } from '@mui/icons-material';
import { Button, Paper, Typography } from '@mui/material';

type EmptyFundsStateProps = {
  onAddFund: () => void;
};

export function EmptyFundsState({ onAddFund }: EmptyFundsStateProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 4,
        textAlign: 'center',
        backgroundColor: '#fafafa',
      }}>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        Nenhum fundo adicionado
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Clique no botão "Adicionar" para incluir fundos à sua carteira.
      </Typography>
      <Button
        startIcon={<Add />}
        variant="contained"
        color="primary"
        onClick={onAddFund}>
        Adicionar primeiro fundo
      </Button>
    </Paper>
  );
}
